import { FirestoreDataConverter } from "firebase/firestore";
import { omitBy } from "lodash";
import moment from "moment";
import ExercicioDireito from "../models/exercicioDireito";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class ExercicioDireitoDb extends BaseDb<
  ExercicioDireito,
  { usuarioId: string; exercicioDireitoId: string }
> {
  _path: string = "usuarios/usuarioId/exercicioDireito/exercicioDireitoId";
  getConverter(): FirestoreDataConverter<ExercicioDireito> {
    return {
      fromFirestore: (snapshot, _options) =>
        new ExercicioDireito({
          id: snapshot.id,
          codigoAtivo: snapshot.get("codigoAtivo"),
          isinDireito: snapshot.get("isinDireito"),
          dataExercicio: moment(snapshot.get("dataExercicio").toDate()),
          quantidade: snapshot.get("quantidade"),
          precoUnitario: snapshot.get("precoUnitario"),
          codigoObjeto: snapshot.get("codigoObjeto"),
        }),
      toFirestore: (exercicioDireito: ExercicioDireito) =>
        toFirestore(omitBy(exercicioDireito, ["id"])),
    };
  }
}
